{
  "completed": "הושלם:  ",
  "current": "נוכחי: ",
  "notCompleted": "לא הושלם:  ",
  "steplist": "רשימת צעדים"
}
